import { render } from "./HealthSupportPage.vue?vue&type=template&id=20983b3c"
import script from "./HealthSupportPage.vue?vue&type=script&lang=js"
export * from "./HealthSupportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__